import type { SVGProps } from "react";

export function HySelectLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-slot="icon"
      fill="none"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect fill="currentColor" height={24} rx={7} width={24} />
      <circle cx={7} cy={7} fill="white" r={2} />
      <circle cx={12} cy={7} fill="white" r={2} />
      <circle cx={17} cy={7} fill="white" r={2} />
      <circle cx={7} cy={12} fill="white" r={2} />
      <circle cx={7} cy={17} fill="white" r={2} />
      <circle cx={12} cy={12} fill="white" r={2} />
      <circle cx={12} cy={17} fill="white" r={2} />
      <circle cx={17} cy={12} fill="white" r={2} />
      <circle cx={17} cy={17} fill="white" r={2} />
    </svg>
  );
}
